import { useSelector } from 'react-redux';

const useAdmin = () => {
    const isAdmin = useSelector((state) => state.currentUser.isAdmin);

    return isAdmin;
};

export default useAdmin;
